<template>
    <fieldset class="mb-4 grid gap-4 border px-4 py-2">
        <legend>Controls</legend>
        <label>
            Font Awesome icon string
            <input
                v-model="iconString"
                class="my-2 w-full rounded-md border border-teal-500 p-1 font-mono shadow-[0_0_5px] shadow-teal-500"
            />
        </label>

        <label>
            Tooltip text
            <input
                v-model="tooltipText"
                class="my-2 w-full rounded-md border border-teal-500 p-1 font-mono shadow-[0_0_5px] shadow-teal-500"
            />
        </label>

        <div>
            Tooltip location
            <div class="flex items-center gap-6 pt-1">
                <label
                    v-for="location in ['top', 'bottom', 'left', 'right']"
                    :key="location"
                    class="inline-flex items-center gap-2"
                >
                    <input
                        v-model="tooltipLocation"
                        type="radio"
                        :value="location"
                    />
                    {{ location }}
                </label>
            </div>
        </div>
    </fieldset>

    <h2>Icon button</h2>
    <DsButtonSampleSet
        :icon="iconString"
        :tooltipLocation="tooltipLocation"
        :tooltipText="tooltipText"
        variant="icon"
    />
</template>

<script setup lang="ts">
import type { TooltipPlacementType } from '@/components/design-system/design-system';
import { ref } from 'vue';
import DsButtonSampleSet from '@ds/design-samples/DsButtonSamples/DsButtonSampleSet.vue';

const iconString = ref('fa-solid fa-xmark');
const tooltipLocation = ref<TooltipPlacementType>('top');
const tooltipText = ref('Close');
</script>
